<template>
  <div class="home">
    <div class="content">
      <div class="container-fluid">


 
          <div class="col-12 btn-voltar" @click="$router.go(-1)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-rewind" viewBox="0 0 16 16">
              <path d="M9.196 8 15 4.633v6.734zm-.792-.696a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z"/>
              <path d="M1.196 8 7 4.633v6.734zm-.792-.696a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z"/>
            </svg>
            VOLTAR
          </div>

        
        
        <div class="col-12 pt-4">
          <h1 class="titillium-web-bold">Tarefa Solidária Jogos Interclasse</h1>
          <h4 class="titillium-web-light">Acompanhe os resultados da arrecadação de alimentos!</h4>
        </div>
        <div class="row pt-4">
          <div class="title-setor">SALA: {{ sala_atual }}</div>

          <div class="col-6" v-for="(value, key) in meta_sala" :key="key">
            <div class="holder-salas "  v-if="!loading_percent">
              <div class="sala titillium-web-bold text-center pt-2" style="font-size: 14px;">{{ key }}</div>
              <div class="descricao-sala text-center titillium-web-semibold">arrecadado</div>
              <div class="porcentagem text-center titillium-web-bold pt-2">
                {{ Math.floor(!isNaN(arrecadacao_sala[key] * 100 / meta_sala[key]) ? (arrecadacao_sala[key] * 100) / meta_sala[key] : 0) }} %
              </div>
              <div class="percent-donate"
                  :class="{
                      'blue-bg': (!isNaN((arrecadacao_sala[key] * 100) / meta_sala[key]) && ((arrecadacao_sala[key] * 100) / meta_sala[key]) >= 0 && ((arrecadacao_sala[key] * 100) / meta_sala[key]) < 40),
                      'yellow-bg': (!isNaN((arrecadacao_sala[key] * 100) / meta_sala[key]) && ((arrecadacao_sala[key] * 100) / meta_sala[key]) >= 40 && ((arrecadacao_sala[key] * 100) / meta_sala[key]) < 75),
                      'green-bg': (!isNaN((arrecadacao_sala[key] * 100) / meta_sala[key]) && ((arrecadacao_sala[key] * 100) / meta_sala[key]) >= 75)
                  }"
                  :style="{ height: (!isNaN((arrecadacao_sala[key] * 100) / meta_sala[key]) ? ((arrecadacao_sala[key] * 100) / meta_sala[key]) + '%' : '0%') }"
              ></div>
            </div>
            <div v-else class="text-center p-4">
              <div class="spinner-border text-light" role="status">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $firebase } from '../services/firebase'

export default {
  data() {
    return {
      server: "http://localhost:8080",
      sala_atual: this.$route.params.classe,
      meta_sala:{},
      arrecadacao_sala:{},
      loading_percent: true
    };
  },
  methods: {
    redirect(param) {
        this.$router.push('/metas/EF'+param);
    },

    async metasDetails() {
      try {
        let classeFilter = 0;
        const classeParam = this.$route.params.classe.substring(0, 3);

        if (classeParam == "EF6") {
          classeFilter = 16;
        } else if (classeParam == "EF7") {
          classeFilter = 17;
        } else if (classeParam == "EF8") {
          classeFilter = 18;
        } else if (classeParam == "EF9") {
          classeFilter = 19;
        }else{
          classeFilter = 16;

        }
        const snapshot = await $firebase.database().ref('metas/' + classeFilter).once('value');
        const meta_sala = {};
        snapshot.forEach(childSnapshot => {
          meta_sala[childSnapshot.key] = childSnapshot.val().meta;
        });
        this.meta_sala = meta_sala;
      } catch (error) {
        console.error('Erro ao buscar metas:', error);
        throw error;
      }
    },


    async donatesDetails() {
      try {
        const snapshot = await $firebase.database().ref('donates/'+this.sala_atual).once('value');
        const arrecadacao_sala = {};

        snapshot.forEach(childSnapshot => {
          // Inicializa o objeto aninhado com a chave childSnapshot.key se ainda não existir

          childSnapshot.forEach(idSnapShot =>{


          
            const produto = idSnapShot.val().produto;
            const quantidade = idSnapShot.val().quantidade;


              // Verifica se o produto já foi adicionado à sala
              if (!arrecadacao_sala[produto]) {
                // Se não, inicializa sua quantidade como 0
                arrecadacao_sala[produto] = 0;
              }

              
              // Adiciona a quantidade ao objeto aninhado
              arrecadacao_sala[produto] += quantidade;

          })

        });

        // Atualiza a variável arrecadacao_sala com o objeto criado
        this.arrecadacao_sala = arrecadacao_sala;
        this.loading_percent = false

      } catch (error) {
        console.error('Erro ao buscar doações:', error);
      }
    },


  },
  async mounted() {
    try {
      this.metasDetails(),
      this.donatesDetails()
    }catch (error){
      console.error('Erro ao montar o componente:', error);

    }
  }
};
</script>

